import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { clientKindSchema } from '../client-kind';

const c = initContract();

export const clientSearchRowSchema = z.object({
    clientId: z.string(),
    name: z.string(),
    clientKind: clientKindSchema.nullable(),
});
export type ClientSearchRow = z.infer<typeof clientSearchRowSchema>;

export const clientSearchResponseSchema = z.object({
    rows: z.array(clientSearchRowSchema),
});
export type ClientSearchResponse = z.infer<typeof clientSearchResponseSchema>;

export const clientsContract = c.router(
    {
        searchClients: {
            method: 'GET',
            path: '/clients',
            query: z.object({ search: z.string().optional() }).optional(),
            responses: { 200: clientSearchResponseSchema },
            summary: 'Client directory for registered holders',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
